/**
 * Stack is implemented for control and stash registers.
 */
interface IStack<T> {
  push(...items: T[]): void;
  pop(): T | undefined;
  peek(): T | undefined;
  peekAt(depthFromTop: number): T | undefined;
  size(): number;
  isEmpty(): boolean;
  getStack(): T[];
}

export class Stack<T> implements IStack<T> {
  // Bottom of the array is at index 0
  public storage: T[] = [];

  public constructor() {}

  public push(...items: T[]): void {
    for (const item of items) {
      this.storage.push(item);
    }
  }

  public pop(): T | undefined {
    return this.storage.pop();
  }

  public peek(): T | undefined {
    if (this.isEmpty()) {
      return undefined;
    }
    return this.storage[this.size() - 1];
  }

  /** `peekAt(0)` is the top (same as `peek()`); `peekAt(n)` looks n items below it. */
  public peekAt(depthFromTop: number): T | undefined {
    const index = this.size() - 1 - depthFromTop;
    if (index < 0) {
      return undefined;
    }
    return this.storage[index];
  }

  public size(): number {
    return this.storage.length;
  }

  public isEmpty(): boolean {
    return this.size() == 0;
  }

  public getStack(): T[] {
    // return a copy of the stack's contents
    return [...this.storage];
  }

  public some(predicate: (value: T) => boolean): boolean {
    return this.storage.some(predicate);
  }
}
